import { AdviseEngagement, MatrixCriterion, MatrixFeature } from '../types/advise';

// A cleared criterion's features are kept for when it is selected again, but count for nothing meanwhile.
// Notes are saved by feature key, since some labels repeat across categories; older notes were saved by label.
export const featureNote = (
  featureNotes: AdviseEngagement['feature_notes'] | undefined,
  feature: MatrixFeature
): string | undefined => {
  const notes = Object.values(featureNotes || {}).reduce((all, group) => ({ ...all, ...group }), {});
  return notes[feature.key] ?? notes[feature.label];
};

export const selectedFeatures = (criteria: MatrixCriterion[]): MatrixFeature[] =>
  criteria
    .filter((criterion) => criterion.selected)
    .flatMap((criterion) => criterion.categories.flatMap((category) => category.features))
    .filter((feature) => feature.selected);
